<template>
    <div>
        <div class="container-fluid featured-image">
            <div class="container-fluid featured-image-overlay">
                <div class="featured-text">
                    <span class="feature-content">
                        <p class="feature-header">DR GILBERT ANDREWS</p>
                        <hr>
                        <p class="feature-sub-header">FRCPsych DPM</p>
                        <p class="feature-sub-header">Consultant Psychiatrist</p>
                    </span>
                </div>
            </div>
        </div>
         <div class="container">
            <div class="row">
                <div class="col-md-12 experience-section">
                    <h1 align="centre">My Experience</h1>
                    <hr align="centre">
                    <div class="row">
                        <div class="col-lg-8">
                            <p>I am a Consultant Psychiatrist specialising in the assessment and treatment of all forms of major mental illnesses. I am a Fellow of the Royal College of Psychiatrists and hold a Diploma in Psychological Medicine.</p>
                            <p>I practised as a Consultant Psychiatrist in the NHS for over 20 years and have been the Medical Director for an NHS Trust. I was the Medical Director for the Priory Hospital, Woking, and later Responsible Officer for an independent hospital.</p>
                            <p>I am engaged in private practice based in Surrey and Berkshire. I am a Cardiff University accredited Expert Witness and carry out medico-legal work. </p>
                        </div>
                        <div class="col-lg-4">
                            <img src="@/assets/images/drandrews.jpg" class="doctor-image w-75 float-right">
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="services-section philosophy-section">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12">
                        <h1>My Philosophy</h1>
                        <hr>
                        <p class="philosophy-p">My philosophy of care is to help patients to understand their illness and equip them with knowledge and certain skills to manage their illness and lead a normal life. </p><p>I adopt a holistic approach to psychological illness with interactive therapy using mindfulness, CBT, anxiety management and medication. </p>
                    </div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="row">
                <div class="col-md-12 experience-section">
                    <h1 align="centre">Assessment/Treatment</h1>
                    <hr align="centre">
                    <p class="text-center" >I provide consultations for a wide range of emotional and mental health problems:</p>
                    <br>
                    <div class="row">
                        <div class="col-lg-4 offset-lg-2">
                            <ul class="disorder-types">
                                <li>Generalised anxiety disorder</li>
                                <li>Panic disorder</li>
                                <li>Post-traumatic stress disorder</li>
                                <li>ADHD / Adult</li>
                            </ul>
                        </div>
                        <div class="col-lg-4">
                            <ul class="disorder-types">
                                <li>Mood disorders - depressive illness</li>
                                <li>Addiction disorders</li>
                                <li>Psychiatry of older adults</li>
                                <li>Mental capacity assessments</li>
                            </ul>
                        </div>
                        <div class="col-12 pt-3 text-center">
                            <p>I follow NICE guidelines to provide evidence based treatment. I work with a range of psychologists and therapists in that area to provide wider therapeutic options.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
         <div class="container box-section">
            <div class="row">
                <div class="col-lg-5 col-md-12 services-section mx-auto">
                   <h1>My Services</h1>
                   <hr class="box-break">
                   <p>Initial Assessment</p>
                   <p>Follow Up Treatment</p>
                   <p>Medico Legal Reports</p>
                   <p>Capacity Assessments</p>
                   <button class="box-button"><router-link to="/my-services">Find Out More</router-link></button>
                </div>
                <div class="col-lg-5 col-md-12 office-section mx-auto">
                    <h1>My Offices</h1>
                    <hr class="box-break">
                    <p>Woking</p>
                    <p>Windsor</p>
                    <p>Weybridge</p>
                  <br />
                    <button class="box-button"><router-link to="/my-offices">Find Out More</router-link></button>
                </div>
            </div>
        </div>
        <div class="container-fluid bg">
            <div class="container contact-us-section">
                <div class="row text-center">
                    <div class="col-lg-9 col-sm-12">
                        <p>To make an appointment, contact Julie Cook, Practice Manager on <a href="tel:01276857090" onclick="gtag('event', 'Number', { 'event_category': 'Phone', 'event_label': 'Clicked' });">01276 857090</a></p>
                        <p>or by email: <a href="mailto:info@drandrewsoffice.co.uk" onclick="gtag('event', 'Clicked', { 'event_category': 'Email', 'event_label': 'Complete' });">info@drandrewsoffice.co.uk</a></p>
                        <p>Alternatively fill out my online contact form</p>
                    </div>
                    <div class="col-lg-3 col-sm-12">
                        <router-link to="/contact" class=" header-nav-link"><button class="contact-button">Get In Touch</button></router-link>
                    </div>
                </div>
            </div>
        </div>
        <div class="container" id="testimonials">
            <div class="row">
                <div class="col-sm-1">
                    <p class="left-quote">&ldquo;</p>
                </div>
                <swiper :options="swiperOption" class="col-sm-10 quote-content">
                    <!-- slides -->
                    <swiper-slide>
                        <div>
                            <p>Dr Andrews is a very supportive colleague who can always be relied upon to give Psychiatric care and attention promptly to private patients. I find his letters informative and helpful in providing continuity of care from general practice - General Practitioner</p>
                        </div>
                    </swiper-slide>
                    <swiper-slide>
                        <div class="col-sm-10 quote-content">
                            <p>A very sympathetic and effective doctor - Patient</p>
                        </div>
                    </swiper-slide>
                    <swiper-slide>
                        <div class="col-sm-10 quote-content">
                            <p>Dr Andrews treated myself as an equal person, not just a patient - Patient</p>
                        </div>
                    </swiper-slide>
                </swiper>
                <div class="col-sm-1">
                    <p class="right-quote">&rdquo;</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import 'swiper/dist/css/swiper.css'

import { swiper, swiperSlide } from 'vue-awesome-swiper'

export default {
  components: {
    swiper,
    swiperSlide
  },
  name: 'Home',
  data () {
    return {
      swiperOption: {
        spaceBetween: 30,
        centeredSlides: true,
        autoplay: {
          delay: 7500,
          disableOnInteraction: false
        }
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

</style>



// WEBPACK FOOTER //
// src/components/pages/Home.vue